import Image from 'next/image'
import React from 'react'

type TActivityIndicator = {
  readonly size: 'small' | 'large'
}

export default function ActivityIndicator({ size }: TActivityIndicator) {
  return (
    <Image
      src={`/assets/images/loading.png`}
      alt='loading_state'
      width={100}
      height={100}
      className={`${size === 'small' ? 'h-5 w-5' : 'h-10 w-10'} animate-spin`}
      data-testid='loading-icon'
    />
  )
}
